import { render, staticRenderFns } from "./EnderecoNacional.vue?vue&type=template&id=125f7555&scoped=true&"
import script from "./EnderecoNacional.vue?vue&type=script&lang=js&"
export * from "./EnderecoNacional.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoNacional.vue?vue&type=style&index=0&id=125f7555&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f7555",
  null
  
)

export default component.exports